import React from "react";

import * as Sentry from "@sentry/react";

import ErrorFallback from "../ErrorFallback";

const AppRoot = ({ children }: { children: React.ReactNode }) => {
	return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
};

export default AppRoot;
